import About from '@/components/About.vue'
import ContactUs from '@/components/ContactUs.vue'
import Home from '@/components/Home.vue'
import LogInClient from '@/components/LogInClient.vue'
import Profile from '@/components/Profile.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import SignUpClient from '@/components/SignUpClient.vue'
import VerifyYourAccount from '@/components/VerifyYourAccount.vue'

export default [
  {
    component: About,
    path: '/about'
  },
  {
    component: ContactUs,
    path: '/contact-us'
  },
  {
    component: Home,
    meta: {
      requiresClientStatus: true
    },
    name: 'home',
    path: '/'
  },
  {
    beforeEnter () { location.href = 'https://www.godo.fitness/legal/' },
    path: '/legal'
  },
  {
    component: LogInClient,
    meta: {
      name: 'Log In',
      requiresNullToken: true
    },
    path: '/log-in'
  },
  {
    beforeEnter () { location.href = 'https://www.godo.fitness/legal/privacy-policy/' },
    path: '/privacy-policy'
  },
  {
    component: Profile,
    meta: {
      requiresToken: true
    },
    path: '/profile'
  },
  {
    component: ResetPassword,
    meta: {
      name: 'Reset Password',
      requiresNullToken: true
    },
    path: '/reset-password'
  },
  {
    component: SignUpClient,
    meta: {
      name: 'Sign Up',
      requiresNullToken: true
    },
    path: '/sign-up'
  },
  {
    beforeEnter () { location.href = 'https://www.godo.fitness/legal/user-terms/' },
    path: '/terms'
  },
  {
    component: VerifyYourAccount,
    meta: {
      name: 'Verify Your Account',
      requiresToken: true
    },
    path: '/verify-your-account'
  },
  {
    redirect: '/',
    path: '*'
  }
]
